import { UserRole } from '@nextforce/api'
import { StackNavigationProp } from '@react-navigation/stack'
import { Divider, Icon, Text, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import { HomeStackParamList } from 'home/stack/types'
import { View } from 'react-native'
import {
  DropdownItem,
  DropdownItemComponentProps,
  DropdownSection,
} from 'shared/components/dropdown'
import { showHeaderTitleDropdown } from 'shared/header/header_title_dropdown'

export const USER_ROLE_DROPDOWN_TYPES: UserRole[] = [
  'observer',
  'staff',
  'guest',
]

function getUserRoleHeaderSections(): DropdownSection[] {
  const items: DropdownItem[] = USER_ROLE_DROPDOWN_TYPES.map((type, index) => ({
    id: index,
    name: getUserRoleName(type),
  }))
  return [
    {
      data: items,
      ItemSeparatorComponent: DividerComponent,
    },
  ]
}

function UserRoleDropdownItemComponent({
  item,
  selected,
}: DropdownItemComponentProps) {
  const styles = useStyles()
  return (
    <View style={styles.item}>
      <Text>{item.name}</Text>
      {selected ? (
        <Icon name="check" style={styles.check} color={styles.check.color} />
      ) : null}
    </View>
  )
}

function DividerComponent() {
  return <Divider />
}

export function getUserRoleName(role?: UserRole) {
  switch (role) {
    case 'observer':
      return t('managementTeam')
    case 'guest':
      return t('guestTeam')
    case 'staff':
      return t('staffTeam')
    default:
      return ''
  }
}

export function showUserRoleHeaderDropdown(
  navigation: StackNavigationProp<HomeStackParamList>,
  selectedIndex: number,
  onSelect: (id: number) => void
) {
  const sections = getUserRoleHeaderSections()

  const index = sections[0].data.findIndex(item => item.id === selectedIndex)
  showHeaderTitleDropdown(
    navigation,
    sections,
    index,
    onSelect,
    undefined,
    undefined,
    undefined,
    UserRoleDropdownItemComponent
  )
}

const useStyles = makeStyles(theme => ({
  item: {
    paddingLeft: 10,
    width: 200,
    height: 50,
    marginRight: 10,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.white,
  },
  check: {
    marginLeft: 5,
    color: theme.colors.primary,
  },
}))
